import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const names = ['Martín L.', 'Lucía G.', 'Santiago R.', 'Valentina M.', 'Mateo P.', 'Camila S.', 'Nicolás F.', 'Sofía D.', 'Tomás B.', 'Florencia A.', 'Agustín V.', 'Carolina T.', 'Federico H.', 'Julieta C.', 'Gonzalo E.', 'Milagros R.', 'Leandro K.', 'Rocío N.', 'Ezequiel W.', 'Aldana J.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis', 'Corrientes', 'Paraná', 'San Miguel de Tucumán', 'Formosa', 'Río Cuarto'];
const timeAgo = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos', 'hace 20 minutos', 'hace 25 minutos', 'hace 30 minutos', 'hace 1 hora'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  const showNotification = useCallback(() => {
    setData({
      name: getRandomItem(names),
      city: getRandomItem(cities),
      time: getRandomItem(timeAgo)
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    // First popup after 8 seconds
    const initialTimer = setTimeout(() => {
      showNotification();
    }, 8000);
    // Then every 18-25 seconds
    const interval = setInterval(() => {
      showNotification();
    }, 18000 + Math.random() * 7000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [showNotification]);
  return <AnimatePresence data-id="element-381">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed top-6 left-6 z-50 max-w-xs" data-id="element-382">
          <div className="bg-gray-700 border-2 border-primary/40 rounded-xl shadow-[0_4px_24px_rgba(0,0,0,0.25)] p-4 flex items-start gap-3 relative" data-id="element-383">
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-384">
              <XIcon className="w-3.5 h-3.5" data-id="element-385" />
            </button>

            <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center shrink-0" data-id="element-386">
              <ShoppingBagIcon className="w-5 h-5 text-primary" data-id="element-387" />
            </div>

            <div className="pr-4" data-id="element-388">
              <p className="text-sm text-white font-semibold leading-tight" data-id="element-389">
                {data.name}
              </p>
              <p className="text-xs text-gray-300 mt-0.5" data-id="element-390">
                compró el Pack desde{' '}
                <span className="font-medium text-primary" data-id="element-391">{data.city}</span>
              </p>
              <p className="text-[11px] text-gray-400 mt-1" data-id="element-392">{data.time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}